module.exports = __webpack_public_path__ + "assets/img/Record_tit.611877d3.png";